<template>
  <div class="rental-company-edit">
    <data-form
      :title="title"
      tag="rental-company-edit"
      save-button-label="Save"
      :field-model="rentalCompanyFields"
      :field-groups="fieldGroups"
      :load-model-instance="loadModelInstance"
      :on-submit-handler="onSubmit"
      :cancelRoute="`/rentalcompany/view/${rentalCompanyId}`"
      submit-success-message="Rental Company updated"
      submit-error-message="Error updating rental company"
      :submit-success-route="`/rentalcompany/view/${rentalCompanyId}`"
    >
    </data-form>
  </div>
</template>

<script>
import Vue from 'vue'
import RentalCompanyFields from '@/models/RentalCompany'

export default Vue.extend({
    name: 'RentalCompanyEdit',
    props: {
        rentalCompanyId: Number,
    },
    data () {
        return {
            title: 'Edit Rental Company',
            rentalCompanyFields: RentalCompanyFields,
            fieldGroups: [
                ['id', 'name', 'address_1', 'address_2', 'city', 'state', 'zip', 'phone', 'email'],
                ['status'],
            ],
        }
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'rental-company', this.rentalCompanyId)
                .then((rentalCompany) => {
                    this.title = 'Edit ' + rentalCompany.name
                    return rentalCompany
                })
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'rental-company', modelInstance)
        },
    }
})
</script>

<style lang="scss">
.rental-company-edit {
  max-width: 1600px;
  margin: 0 auto;
}
</style>
